import Typography from '@pedidosya/web-fenix/foundations/Typography';
import Rating from '@pedidosya/web-fenix/patterns/Rating';
import Tag from '@pedidosya/web-fenix/system/Tag';
import styled from 'styled-components';
import { Space } from '../../Space/Space';
import { CPCContainer, Row, TextSeparator } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';
import { CategoriesRow } from './CategoriesRow';
import { TagsRow } from './TagsRow';

const TypographyWeb = styled(Typography)`
  &.two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const RatingContainer = styled.div`
  margin-top: ${({ theme }) => theme.space('spacing-component-xsmall')};
`;

const LeftColumn = styled.div`
  align-self: flex-start;
  display: flex;
  flex-wrap: nowrap;
`;

const RightColumn = styled.div`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
`;

const textProps = vendorItemTokens.properties.fonts;

export const HeadlineRow = ({
  vendorName,
  isNew,
  rating,
  mainCategories,
  discountLabel,
  renderPlusTag,
  sponsoringLabel,
  shouldRenderSponsoringLabelInBody,
}) => (
  <>
    <Row color={textProps.headline.textColor}>
      <LeftColumn>
        <TypographyWeb
          className="two-line-ellipsis"
          component="h1"
          token={textProps.headline.typography}
        >
          {vendorName}
        </TypographyWeb>
      </LeftColumn>
      <Space mr={6} />

      {(!!discountLabel || !!renderPlusTag) && (
        <TagsRow discountLabel={discountLabel} renderPlusTag={renderPlusTag} />
      )}
      {rating && (
        <>
          <Space mr={6} />
          <div style={{ marginBottom: 4 }}>
            <TextSeparator>·</TextSeparator>
          </div>
        </>
      )}
      <Space mr={6} />
      <RightColumn>
        <RatingContainer>
          {!isNew && rating > 0 && <Rating value={rating} />}
          {!!isNew && (
            <div style={{ marginTop: -2 }}>
              <Tag category="loud" label="Nuevo" />
            </div>
          )}
        </RatingContainer>
      </RightColumn>
      <Space mr={6} />
      {shouldRenderSponsoringLabelInBody && (
        <div style={{ marginBottom: 3 }}>
          <TextSeparator>·</TextSeparator>
        </div>
      )}
      <Space mr={6} />
      {shouldRenderSponsoringLabelInBody && (
        <CPCContainer>
          <TypographyWeb
            color="text-color-tertiary"
            token="font-label-midcontrast-small"
          >
            {sponsoringLabel}
          </TypographyWeb>
        </CPCContainer>
      )}
    </Row>
    {!!mainCategories && mainCategories.length > 0 ? (
      <CategoriesRow mainCategories={mainCategories} />
    ) : null}
  </>
);
